import { logSystem } from 'logger';
import { transportRegistry } from '../Service';
import { ServiceDef, RegistryItem } from '../interfaces';

function postRequest(url = ``, data: string): Promise<any> {
	return fetch(url, {
		method: 'POST', // *GET, POST, PUT, DELETE, etc.
		mode: 'same-origin', // no-cors, cors, *same-origin
		cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
		credentials: 'same-origin', // include, same-origin, *omit
		headers: {
			'Content-Type': 'application/json; charset=utf-8'
		},
		redirect: 'follow', // manual, *follow, error
		referrer: `${window.hcstatic.portal_url}/`, // no-referrer, *client
		body: data // body data type must match "Content-Type" header
	}).then((response) => response.json()); // parses response to JSON
}

const postTransport: RegistryItem = {
	fire(r: ServiceDef) {
		const promise = new Promise((resolve, reject) => {
			postRequest(r.target!, r.data).then(
				(v: any) => {
					// logSystem.debug({ msg: `${r.target} =>`, data: v });
					resolve(v);
				},
				(e: any) => {
					logSystem.error(`${r.target} !!!=>`, e);
					reject(e);
				}
			);
		});
		return promise;
	}
};

transportRegistry.set('POST', postTransport);
